import type { Route, RouteConfig } from 'vue-router'
import { isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import {
  ORGANIZATION_ROUTE_NAME,
  ORGANIZATION_FILTERED_ROUTE_NAME,
} from '@/contexts/organization/Organization.constants'

export const organizationRoutes: RouteConfig = {
  path: '/modeling',
  name: ORGANIZATION_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/organization/OrganizationView.vue')),
  meta: {
    i18nTitle: 'organization.menu.title',
    icon: 'sitemap',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'organization',
    feature_id: 'SECURITY_BASE',
  },
  children: [
    {
      path: 'filtered/list',
      name: ORGANIZATION_FILTERED_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/organization/OrganizationFilteredView.vue')),
      meta: {
        i18nTitle: 'organization.menu.advanced_filter',
        icon: 'stream',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'filtered_perimeter',
      },
    },
  ],
}
